<template>
  <div class="address page-container bg-white">
    <div class="pageHead-wrapper">
      <PageHeader title="收货信息管理">
        <template slot="icon">
          <img :src="pageIcon" width="16px" height="16px" alt="">
        </template>
      </PageHeader>
    </div>
    <!-- 查询表单 -->
    <div class="search-panel">
      <Json2Form
        :form="form"
        :fieldsSource="fieldsSource"
        :options="options"
        :btns="btns"
        formClass="json2form"
        @submit="handleSubmit"
        ref="search-form"
      />
    </div>
    <!-- 列表 -->
    <div class="content">
      <a-button
        type="primary"
        class="greenBtn"
        icon="plus"
        @click="openAddModal()"
      >
        新增收货地址
      </a-button>
			<Table
        :columns="columns"
        :data-source="tableData"
        :scroll="{ x: 1400 }"
        :pagination="ipagination"
        rowKey="uuid"
        :loading="tableLoading"
        @change="handleTableChange"
      >
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a-button type="link" @click="openEditModal(record)">
              编辑
            </a-button>
            <a-button
              type="link"
              @click="handleDel(record)"
            >
              删除
            </a-button>
          </a-space>
        </template>
      </Table>
    </div>
    <!-- 弹出框 -->
    <Confirm
      :visible="deleteVisible"
      okText="删除"
      @cancel="cancelDeleteDialog"
      @ok="confirmDeleteDialog"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
    >
      是否删除当前收货信息？
    </Confirm>
    <a-modal
      v-model="modelVisible"
      :title="isAdd ? '新增收货信息' : '编辑收货信息'"
      :destroyOnClose="true"
      @ok="modelConfirm"
      :width="500"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      dialogClass="commonModal"
    >
      <a-form layout="vertical" :form="modelForm" @submit="handleSubmit">
        <a-form-item label="供应商">
          <a-select
            v-decorator="['supplier_code', {
              rules: [
                {
                  required: true,
                  message: '请选择供应商',
                },
              ],
              }
            ]"
          >
            <a-select-option v-for="(item, index) in supplier" :key="index" :value="item.code">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="收货地址">
          <a-input
            v-decorator="[
              'address',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入收货地址',
                  },
                ],
              },
            ]"
            :maxLength="100"
          />
        </a-form-item>
        <a-form-item label="联系人">
          <a-input
            v-decorator="[
              'user',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入联系人',
                  },
                ],
              },
            ]"
            :maxLength="10"
          />
        </a-form-item>
        <a-form-item label="联系电话">
          <a-input
            v-decorator="[
              'tel', {
                rules: [
                  {
                    required: true,
                    message: '请输入联系电话',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Json2Form from '@/components/Json2Form';
import PageHeader from '@/components/PageHeader/customPageHeader';
import { Table, Confirm } from '@/components/';
import { FIELD_SOURCE, ADDRESS_COLUMS } from './constants/';
import { getBaseInfo, getContactList, getContactAdd, getContactEdit, getContactDel } from '@/api/address/';
import { formatOptionsData } from '@/utils/formatData/';
import { paginationItem } from '@/constants/goods/';

export default {
  name: 'TableList',
  components: {
    Json2Form,
    PageHeader,
    Table,
    Confirm,
  },
  data() {
    return {
      form: {},
      columns: ADDRESS_COLUMS,
      fieldsSource: FIELD_SOURCE,
      tableData: [],
      record: {}, // 点击的当前记录
      tableLoading: false,
      deleteVisible: false,
      modelVisible: false,
      confirmLoading: false,
      isAdd: false,
      modelTitle: '',
      pageIcon: require('@/assets/img/address.png'),
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        ...paginationItem,
      },
      btns: [
        {
          action: 'submit',
          text: '查询',
          style: {
            color: '#fff',
            background: '#345FEC',
            border: 'none',
          },
        },
        {
          action: 'reset',
          text: '重置',
          force: true,
        },
      ],
      options: {
        layout: 'inline',
        gutter: 12,
        labelCol: {
          xl: {
            span: 8,
          },
          xxl: {
            span: 6,
          },
        },
        wrapperCol: {
          xl: {
            span: 16,
          },
          xxl: {
            span: 18,
          },
        },
      },
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
      supplierDefaultVal: '',
      supplier: [],
    };
  },
  beforeCreate() {
    this.modelForm = this.$form.createForm(this, { name: 'register' });
  },
  mounted() {
    getBaseInfo({
      options: ['line', 'supplier', 'source_type'],
    }).then((res) => {
      this.supplier = res.supplier;
      const options = formatOptionsData('code', 'name', res.supplier);
      this.fieldsSource = (this.fieldsSource || []).map((r) => {
        if (r.name === 'supplier_code') {
          return {
            ...r,
            props: {
              ...(r.props || {}),
              options,
            },
          };
        }
        return r;
      });
    });
    this.handleSubmit();
  },
  methods: {
    // 删除收货信息
    handleDel(record) {
      this.record = record;
      this.deleteVisible = true;
    },
    cancelDeleteDialog() {
      this.deleteVisible = false;
    },
    confirmDeleteDialog() {
      this.confirmLoading = true;
      getContactDel({ uuid: this.record.uuid })
        .then(() => {
          this.deleteVisible = false;
          this.confirmLoading = false;
          this.handleSubmit();
        });
    },
    // 电话校验
    isTelCode(str) {
      const reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
      return reg.test(str);
    },
    validateTel(_, value, callback) {
      if (!value) {
        return callback();
      }
      const val = value.replace(/[^0-9]/g, '');
      this.$nextTick(() => {
        this.modelForm.setFieldsValue({
          tel: val,
        });
        callback();
      });
    },
    // 打开编辑弹框
    openEditModal(record) {
      this.record = record;
      this.isAdd = false;
      this.modelVisible = true;
      this.$nextTick(() => {
        this.modelForm.setFieldsValue({
          supplier_code: this.record.supplier_code,
          address: this.record.address,
          user: this.record.user,
          tel: this.record.tel,
        });
      });
    },
    // 打开新增弹框
    openAddModal() {
      this.isAdd = true;
      this.modelVisible = true;
    },
    // model确定
    modelConfirm() {
      this.modelForm.validateFields((error, value) => {
        if (error) return;
        const index = this.supplier.findIndex((v) => v.code === value.supplier_code);
        const params = {
          ...value,
          supplier_name: this.supplier[index].name,
        };
        this.isAdd
          ? this.addAddress(params)
          : this.editAddress(params);
      });
    },
    // 新增收货地址
    addAddress(params) {
      this.confirmLoading = true;
      getContactAdd(params).then(() => {
        this.modelVisible = false;
        this.confirmLoading = false;
        this.handleSubmit();
      });
    },
    // 编辑收货地址
    editAddress(params) {
      this.confirmLoading = true;
      getContactEdit({
        ...params,
        uuid: this.record.uuid,
      }).then(() => {
        this.modelVisible = false;
        this.confirmLoading = false;
        this.handleSubmit();
      });
    },
    // 查询
    handleSubmit() {
      const formData = this.$refs['search-form'].getFieldsValue();
      this.tableLoading = true;
      getContactList({
        supplier: formData.supplier_code,
        current: this.ipagination.current,
        page_size: this.ipagination.pageSize,
      })
        .then((res) => {
          this.ipagination = {
            current: res.current,
            pageSize: res.page_size,
            total: res.total,
            ...paginationItem,
          };
          this.tableData = (res.items || []).map((v) => ({
            ...v,
            update_time: moment(v.update_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
            create_time: moment(v.create_time * 1000).format('YYYY-MM-DD HH:mm:ss'),
          }));
          this.tableLoading = false;
        });
    },
    // 分页改变
    handleTableChange(pagination) {
      this.ipagination.current = pagination.current;
      this.ipagination.pageSize = pagination.pageSize;
      this.handleSubmit();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/index.less";
.address /deep/ .json2form_btn_wrapper{
  padding-top: 0;
}
.ant-form-item{
  margin-bottom: 10px;
}
</style>
